import { getFeColorMatrixValuesForColor, normalizeColorToHex } from './utils';
import { Color } from './types';

export const IMAGE_COLOR_FILTERS_CONTAINER_ID = 'image-color-filters-container';

type ImageColorFilterWithMatrixProps = {
  color: Color;
};
/**
 * https://ardoqcom.atlassian.net/wiki/spaces/INSIGHT/pages/2532966456/Image+color+filters
 */
const ImageColorFilterWithMatrix = ({
  color,
}: ImageColorFilterWithMatrixProps) => (
  <filter id={getImageColorFilterId(color)}>
    <feColorMatrix
      in="SourceGraphic"
      type="matrix"
      result="first"
      values={getFeColorMatrixValuesForColor(color)}
    />
  </filter>
);

/**
 * https://ardoqcom.atlassian.net/wiki/spaces/INSIGHT/pages/2532966456/Image+color+filters
 */
export const getImageColorFilterId = (color: string) =>
  `image-color-filter-${normalizeColorToHex(color)}`;

type WithColors = {
  colors: Color[];
};
/**
 * https://ardoqcom.atlassian.net/wiki/spaces/INSIGHT/pages/2532966456/Image+color+filters
 */
export const ColorFilters = ({ colors }: WithColors) => (
  <svg
    viewBox="0 0 0 0"
    style={{ width: 0, height: 0, position: 'absolute' }}
    id={IMAGE_COLOR_FILTERS_CONTAINER_ID}
  >
    {colors.map(color => (
      <ImageColorFilterWithMatrix
        key={getImageColorFilterId(color)}
        color={color}
      />
    ))}
  </svg>
);
